import React, { FC } from 'react';
import styles from './modal_scrollable_footer.module.scss';

export const ModalScrollableFooter: FC = ({ children }) => (
  <div className={styles.container}>{children}</div>
);
